import { render, staticRenderFns } from "./InvitationError.vue?vue&type=template&id=a27e99b4&scoped=true"
import script from "./InvitationError.vue?vue&type=script&lang=js"
export * from "./InvitationError.vue?vue&type=script&lang=js"
import style0 from "./InvitationError.vue?vue&type=style&index=0&id=a27e99b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27e99b4",
  null
  
)

export default component.exports